import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import { Link } from "gatsby"

import FacioLogoPrimary from "../assets/logos/facio-primary.svg"
import FacioLogoAlternative from "../assets/logos/facio-alternative.svg"

import Menu from "../assets/menu.svg"
import Close from "../assets/close.svg"

import {
  header,
  darkTheme,
  menu,
  logo,
  stateOpen,
  icon,
  linkList,
  deviceMobile,
  close,
  overlayPosition,
  fastPayment,
} from "./header.module.css"

const Header = ({ dark, landingPage, overlay, fastPaymentColor }) => {
  const [isOpen, setOpen] = useState(false)
  const [mobile, setMobile] = useState(false)

  useEffect(() => {
    function mobile() {
      setMobile(window.matchMedia("(max-width: 900px)").matches)
    }
    mobile()
    window.addEventListener("resize", mobile)
    return () => {
      window.removeEventListener("resize", mobile)
    }
  })

  return (
    <header
      className={[
        header,
        dark && darkTheme,
        overlay && overlayPosition,
        fastPaymentColor && fastPayment,
      ].
        filter(Boolean).
        join(" ")}
    >
      <div className="wrapper">
        <div className={menu}>
          <Link to="/">
            {dark ? (
              <FacioLogoAlternative
                className={[logo, isOpen && stateOpen].filter(Boolean).join(" ")}
              />
            ) : (
              <FacioLogoPrimary className={[logo, isOpen && stateOpen].filter(Boolean).join(" ")} />
            )}
          </Link>
          {mobile && !landingPage && (
            <button onClick={() => setOpen(true)}>
              <Menu alt="Ícone de menu" className={icon} />
              <span>menu</span>
            </button>
          )}

          <nav
            className={[linkList, mobile && deviceMobile, isOpen && stateOpen]
              .filter(Boolean) //eslint-disable-line
              .join(" ")} //eslint-disable-line
          >
            {mobile && (
              <button onClick={() => setOpen(false)} className={close}>
                <Close alt="botão fechar" className={icon} />
                <span>fechar</span>
              </button>
            )}
            {!landingPage && (
              <ul>
                <li>
                  <Link to="https://ajuda.facio.com">Central de ajuda</Link>
                </li>
                <li>
                  <Link to="/sobre-a-facio">Sobre a Facio</Link>
                </li>
              </ul>
            )}
          </nav>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  dark: PropTypes.bool,
}

Header.defaultProps = {
  dark: false,
}

export default Header
